module.exports = __webpack_public_path__ + "img/1520964979.59665a71.jpg";